export const ACTION = {
  hydrate: 'HYDRATE',
  setErrors: 'SET_ERRORS',
  setSaving: 'SET_SAVING',
  updateSchedule: 'UPDATE_SCHEDULE',
  addSchedule: 'ADD_SCHEDULE',
  deleteSchedule: 'DELETE_SCHEDULE',
  updateAnchor: 'UPDATE_ANCHOR',
  addAnchor: 'ADD_ANCHOR',
  removeAnchor: 'REMOVE_ANCHOR',
  setCombine: 'SET_COMBINE',
  addTargeting: 'ADD_TARGETING',
  updateTargeting: 'UPDATE_TARGETING',
  removeTargeting: 'REMOVE_TARGETING',
  selectSchedule: 'SELECT_SCHEDULE',
  addEndRule: 'ADD_END_RULE',
  updateEndRule: 'UPDATE_END_RULE',
  removeEndRule: 'REMOVE_END_RULE',
}
